/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { GetterTree } from 'vuex';
import * as types from '@/store/types';
import { RootState } from '../models';
import { PackageState } from './models';

export const getters: GetterTree<PackageState, RootState> = {
  [types.GET_ALL_PACKAGES](state): PackageState['packages'] {
    const sortedPackages = state.packages
      // eslint-disable-next-line no-nested-ternary
      .sort((a, b) => ((a.name > b.name) ? 1 : (b.name > a.name ? -1 : 0)));
    return sortedPackages;
  },

  [types.GET_BRICKS_OF_PACKAGE](state): PackageState['bricks'] {
    return state.bricks;
  },

  [types.GET_LOADING](state): PackageState['loading'] {
    return state.loading;
  },
};
